import { render, staticRenderFns } from "./MineHelp.vue?vue&type=template&id=6fefaaec&scoped=true"
import script from "./MineHelp.vue?vue&type=script&lang=js"
export * from "./MineHelp.vue?vue&type=script&lang=js"
import style0 from "./MineHelp.vue?vue&type=style&index=0&id=6fefaaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fefaaec",
  null
  
)

export default component.exports